// QuickBooks Live (passthrough) API client.
// Mirrors quickbooks-api.ts but talks to /api/integrations/quickbooks-live/*.
// The OAuth flow itself is shared with the synced integration — same Intuit
// app, same callback URL — and is routed by `mode` in the state parameter.

import api from './api';

interface QuickBooksLiveAuthResponse {
  authorizationUrl: string;
}

interface QuickBooksLiveConnectionStatus {
  connected: boolean;
  realmId?: string;
  mode: 'live';
  error?: string;
}

export const quickbooksLiveApi = {
  // Initiate OAuth in live mode.
  initiateConnection: async (
    organizationId: string,
  ): Promise<QuickBooksLiveAuthResponse> => {
    if (!organizationId) {
      throw new Error('Organization ID is required but not provided.');
    }
    const response = await api.post('/api/integrations/quickbooks-live/connect', {
      organizationId,
    });
    return response.data;
  },

  // Health check — refreshes the OAuth token if needed.
  getConnectionStatus: async (
    dataSourceId: string,
  ): Promise<QuickBooksLiveConnectionStatus> => {
    const response = await api.get(
      `/api/integrations/quickbooks-live/status/${dataSourceId}`,
    );
    return response.data;
  },

  disconnect: async (dataSourceId: string): Promise<void> => {
    await api.post(`/api/integrations/quickbooks-live/disconnect/${dataSourceId}`, {});
  },
};
